import { Routes, Route, Outlet } from 'react-router-dom';
import { lazy } from 'react';

// Auth and App routes
import { authRoutes, appRoutes, gameRoutes, gameLoginRoute } from '@/routes/index';

// Layouts
const AuthLayout = lazy(() => import('../layouts/AuthLayout'));
const AdminLayout = lazy(() => import('../layouts/AdminLayout'));

// Private Route
import PrivateRoute from '@/router/PrivateRoute';

// This helper renders routes, optionally wrapping them in a layout
const renderNestedRoutes = (routes) => {
  return (
    routes.map((route) => {
      if (route.children) {
        return (
          <Route key={route.name} path={route.path} element={route.element}>
            {renderNestedRoutes(route.children)}
          </Route>
        );
      }
      return <Route key={route.name} path={route.path} element={route.element} />;
    })
  );
};

const AppRouter = (props) => {
  return (
    <Routes>
      {/* Public Authentication Routes */}
      <Route element={<AuthLayout {...props}><Outlet /></AuthLayout>}>
        {renderNestedRoutes(authRoutes)}
      </Route>

      {/* Public Game Login Route */}
      {renderNestedRoutes(gameLoginRoute)}

      {/* Public Game Routes */}
      {renderNestedRoutes(gameRoutes)}

      {/* Protected Application Routes */}
      <Route element={<PrivateRoute><AdminLayout {...props}><Outlet /></AdminLayout></PrivateRoute>}>
        {renderNestedRoutes(appRoutes)}
      </Route>
    </Routes>
  );
};

export default AppRouter;